import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { activateTrial, getLoggedUser } from '../../actions/api';
import { ACTIVATE_TRIAL_SUCCESS, LOGGED_USER, LOGIN_USER_DETAILS_SUCCESS, } from '../../constants/ActionTypes';
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export const withHandleActivateTrial = (WrappedComponent) => connect(mapStateToProps, mapDispatchToProps)(class HandleActivateTrial extends React.Component {
    constructor() {
        super(...arguments);
        this.handle = () => {
            const { dispatch } = this.props;
            dispatch(activateTrial()).then((action) => {
                if (action.type === ACTIVATE_TRIAL_SUCCESS) {
                    dispatch(getLoggedUser()).then((actionLoggedUser) => {
                        if (actionLoggedUser.type === LOGIN_USER_DETAILS_SUCCESS) {
                            dispatch({
                                type: LOGGED_USER,
                                payload: actionLoggedUser.response.data,
                            });
                        }
                    });
                }
            });
        };
    }
    render() {
        const { user, ...rest } = this.props;
        const trialActivateable = !user.user || !user.user.plan || !user.user.plan.trialExpirationDate;
        return (_jsx(WrappedComponent, { ...rest, handleActivateTrial: this.handle, trialActivateable: trialActivateable }));
    }
});
